
module dgUtils {

    export class DgGuid {
        public static $inject = [];
        public constructor() {

        }

        public generateGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
    }
    angular.module('dgUtils')
        .service('dgGuid', DgGuid);
}